import { AppTrans } from '@mntn-dev/app-common'
import { linkTargetResolver } from '@mntn-dev/app-routing'
import { Feed } from '@mntn-dev/ui-components'
import { ActivityContainer } from '../activity-container.tsx'
import { Link } from '../link.tsx'
import type { ActivityDetailsProps } from './types.ts'

export const ServiceNoteAdded = ({
  activity,
  activity: {
    activityId,
    actor,
    details: {
      activityType,
      data: { target, noteType },
    },
  },
  t,
  onNavigate,
  currentUrl,
}: ActivityDetailsProps<'service_note_added'>) => (
  <ActivityContainer {...{ activity }}>
    <Feed.Summary>
      <AppTrans
        t={t}
        i18nKey={`${activityType}.summary`}
        values={{
          subject: actor.displayName,
          service: target.service,
          noteType,
        }}
      />
    </Feed.Summary>
    <Feed.Annotations>
      <Link
        {...{
          target: linkTargetResolver['project-service']({ target }),
          t,
          onNavigate,
          currentUrl,
          dataTestId: `activity-feed-item-${activityId}-view-project-link`,
          dataTrackingId: `activity-feed-item-${activityId}-view-project-link`,
        }}
      />
    </Feed.Annotations>
  </ActivityContainer>
)
